import { Controller } from "@hotwired/stimulus"

// Wybór szablonu systemowego witryny w selekcie layoutu (wartość "system:<key>",
// pliki z app/views/cms/layouts/template/). Po wyborze dociąga markup do podglądu
// (readonly), a "Dostosuj" odblokowuje kopię do edycji (site[layout_custom_content]).
// Zapis formatki tworzy z tego layout witryny (sites_controller#apply_system_layout).
export default class extends Controller {
  static targets = ["select", "wrapper", "textarea", "customize", "restore", "preview"]
  static values = { url: String, viewUrl: String }

  connect() {
    this.baseContent = ""
    this.toggle()
  }

  async toggle() {
    const value = this.selectTarget.value
    const system = value.startsWith("system:")
    this.wrapperTarget.classList.toggle("hidden", !system)
    if (!system) {
      this.restore()
      return
    }

    const key = value.slice("system:".length)
    // link wizualnego podglądu wybranego szablonu (renderowany z przykładową treścią)
    if (this.hasPreviewTarget) {
      this.previewTarget.href = `${this.viewUrlValue}?value=${encodeURIComponent(key)}`
    }
    try {
      const query = new URLSearchParams({ value: key })
      const resp = await fetch(`${this.urlValue}?${query}`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
      const data = await resp.json()
      this.baseContent = data.content || ""
    } catch {
      this.baseContent = ""
    }
    // markup podmieniamy tylko w trybie readonly - własnej edycji nie nadpisujemy
    if (this.textareaTarget.disabled) this.textareaTarget.value = this.baseContent
  }

  // "Dostosuj" - kopia markupu szablonu staje się edytowalna i pójdzie w formularzu
  // (pole disabled nie jest wysyłane)
  customize() {
    this.textareaTarget.disabled = false
    this.customizeTarget.classList.add("hidden")
    this.restoreTarget.classList.remove("hidden")
    this.textareaTarget.focus()
  }

  // "Przywróć domyślny" - wraca do readonly, zapis użyje szablonu z pliku
  restore() {
    this.textareaTarget.disabled = true
    this.textareaTarget.value = this.baseContent
    this.customizeTarget.classList.remove("hidden")
    this.restoreTarget.classList.add("hidden")
  }
}
